// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let PatientV3Api = class PatientV3Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Create a new Patient.
     * @param patientSaveModel Patient details
     */
    async patientCreateByTenantId(patientSaveModel) {
        const _url_ = '/patient/v3/Patient';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'patientSaveModel' is not null or undefined
        if (patientSaveModel === null || patientSaveModel === undefined) {
            throw new Error('Required parameter patientSaveModel was null or undefined when calling patientCreateByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientSaveModel, "PatientSaveModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientTCEntLib2SecuritySecureModelsSecureInt64Response");
        }
        return response;
    }
    /**
     *
     * @summary Get a Patient
     * @param patientId Patient ID
     */
    async patientGetByTenantId(patientId) {
        const _url_ = '/patient/v3/Patient/{patientId}'
            .replace('{' + 'patientId' + '}', encodeURIComponent(String(patientId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'patientId' is not null or undefined
        if (patientId === null || patientId === undefined) {
            throw new Error('Required parameter patientId was null or undefined when calling patientGetByTenantId.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Search for Patients.
     * @param patientSearchModel Search criteria
     */
    async patientSearchByTenantId(patientSearchModel) {
        const _url_ = '/patient/v3/PatientSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'patientSearchModel' is not null or undefined
        if (patientSearchModel === null || patientSearchModel === undefined) {
            throw new Error('Required parameter patientSearchModel was null or undefined when calling patientSearchByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientSearchModel, "PatientSearchModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientSearchModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Update a Patient.
     * @param patientId Patient ID
     * @param patientSaveModel Patient details
     */
    async patientUpdateByTenantId(patientId, patientSaveModel) {
        const _url_ = '/patient/v3/Patient/{patientId}'
            .replace('{' + 'patientId' + '}', encodeURIComponent(String(patientId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'patientId' is not null or undefined
        if (patientId === null || patientId === undefined) {
            throw new Error('Required parameter patientId was null or undefined when calling patientUpdateByTenantId.');
        }
        // verify required parameter 'patientSaveModel' is not null or undefined
        if (patientSaveModel === null || patientSaveModel === undefined) {
            throw new Error('Required parameter patientSaveModel was null or undefined when calling patientUpdateByTenantId.');
        }
        let requestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientSaveModel, "PatientSaveModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientResponseModel");
        }
        return response;
    }
    /**
     *
     * @summary Create a new Patient.
     * @param secureUpsearchModelPatientPatientUpsearchModel Patient details
     */
    async patientUpsearchByTenantId(secureUpsearchModelPatientPatientUpsearchModel) {
        const _url_ = '/patient/v3/PatientUpsearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'secureUpsearchModelPatientPatientUpsearchModel' is not null or undefined
        if (secureUpsearchModelPatientPatientUpsearchModel === null || secureUpsearchModelPatientPatientUpsearchModel === undefined) {
            throw new Error('Required parameter secureUpsearchModelPatientPatientUpsearchModel was null or undefined when calling patientUpsearchByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(secureUpsearchModelPatientPatientUpsearchModel, "SecureUpsearchModelPatientPatientUpsearchModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientTCEntLib2SecuritySecureModelsSecureInt64Response");
        }
        return response;
    }
};
PatientV3Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], PatientV3Api);
export { PatientV3Api };
//# sourceMappingURL=patientV3Api.js.map